import React, { useState } from 'react';
import LotteryConfigurationRow from './LotteryConfigurationRow';
import LotteryConfigurationModal from './LotteryConfigurationModal';
import ModalRoot from '../../ModalRoot';
import FlashRoot from '../../FlashMessage/FlashRoot';
import ModalComponent from '../../ModalComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons/faPlusCircle"
import { customers, flashMessages, lotteryConfigurations, modals } from '../../../ducks'
import duckify, { filterDuck, singleDuck } from '../../../utils/duckify';
import { connect } from 'react-redux';
import { compose } from "redux";
import withPagination from "../../../hocs/withPagination";
import Pagination from "react-ultimate-pagination-bootstrap-4";

const LotteryConfigurationsIndex = ({
  allDucksReady,
  customer,
  lotteryConfigurations,
  onCreateNew,
  onDelete,
  onEdit,
  onTest,
  onRun,
  page,
  setPage
}) => {
  const [expandedConfigs, setExpandedConfigs] = useState(new Set());

  const toggleExpanded = (configId) => {
    const newExpanded = new Set(expandedConfigs);
    if (newExpanded.has(configId)) {
      newExpanded.delete(configId);
    } else {
      newExpanded.add(configId);
    }
    setExpandedConfigs(newExpanded);
  };

  const isMultiGrade = (config) => config.grade_configurations && config.grade_configurations.length > 1;

  return (
    <div className="setup">
      <FlashRoot />
      <ModalRoot modals={{ LotteryConfigurationModal, ConfirmRemoveConfiguration, ConfirmRunLottery }} />

      <div className="row title-row">
        <div className="col-18">
          <h2 className="inline">Lotteries</h2>
        </div>
      </div>

      <div className="row add-item-row">
        <div className="col-12">
          <a
            className="add-item-button"
            onClick={() => onCreateNew(customer)}
          >
            <FontAwesomeIcon icon={faPlusCircle} className="me-1" />
            Create a new lottery
          </a>
        </div>
      </div>

      {/* Pagination */}
      {(lotteryConfigurations && lotteryConfigurations.total > 0 && Math.ceil(lotteryConfigurations.total / lotteryConfigurations.perPage) > 1) && (
        <div className='contact-list-react-pagination'>
          <div className='pagination pagination-right'>
            <Pagination
              currentPage={page}
              totalPages={Math.ceil(lotteryConfigurations.total / lotteryConfigurations.perPage)}
              hideFirstAndLastPageLinks
              onChange={(newPage) => setPage(newPage)}
            />
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-24">
          {!allDucksReady && (
            <div className="text-center">
              <i className="fa fa-spinner fa-spin"></i> Loading configurations...
            </div>
          )}

          {allDucksReady && (
            <table className="table table-striped lottery-configurations">
              <thead>
                <tr>
                  <th width="30px"></th>
                  <th className='headers-short'>Apply Year</th>
                  <th className='headers-short'>Apply Grade</th>
                  <th>Size</th>
                  <th>Created At</th>
                  <th>Last Modified</th>
                  <th className='headers-short'>Setup</th>
                  <th className='headers-long'>Status</th>
                  <th className="headers-long">Test Action</th>
                  <th className='headers-long'>Lottery Action</th>
                  <th className='headers-short'></th>
                </tr>
              </thead>
              <tbody>
                {lotteryConfigurations.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No lottery configurations found. Create one to get started.
                    </td>
                  </tr>
                ) : (
                  lotteryConfigurations.map(config => (
                    <React.Fragment key={config.id}>
                      <LotteryConfigurationRow
                        configuration={config}
                        isMultiGrade={isMultiGrade(config)}
                        isExpanded={expandedConfigs.has(config.id)}
                        onToggleExpanded={() => toggleExpanded(config.id)}
                        onEdit={() => onEdit(config, customer)}
                        onDelete={onDelete}
                        onTest={() => onTest(config)}
                        onRerunTest={() => onTest(config)}
                        onRun={() => onRun(config)}
                      />

                      {/* Expanded sub-rows for multi-grade configurations */}
                      {isMultiGrade(config) && expandedConfigs.has(config.id) && (
                        config.grade_configurations.map(gradeConfig => (
                          <LotteryConfigurationRow
                            key={`${config.id}-grade-${gradeConfig.grade_id}`}
                            configuration={config}
                            gradeConfig={gradeConfig}
                            isSubRow={true}
                            onEdit={() => onEdit(config, customer)}
                            onRerunTest={() => onTest(config)}
                          />
                        ))
                      )}
                    </React.Fragment>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

const ConfirmRemoveConfiguration = connect()(({ dispatch, deleting = false, lotteryConfiguration }) => (
  <ModalComponent
    title='Confirm Remove Lottery Configuration'
    buttons={[
      <button
        className='btn btn-danger'
        disabled={deleting}
        onClick={() => {
          dispatch(modals.actions.update({ deleting: false }))
          dispatch(lotteryConfigurations.actions.remove({ id: lotteryConfiguration.id }))
            .then(() => dispatch(modals.actions.hide()))
            .then(() => dispatch(lotteryConfigurations.actions.markDirty()))
            .then(() => dispatch(flashMessages.actions.show({
              type: 'success',
              message: 'Lottery configuration has been removed successfully.',
              dismissible: true,
            })))
            .catch(() => dispatch(modals.actions.show('UnexpectedError')));
        }}
      >
        {deleting ? 'Deleting...' : 'Delete'}
      </button>
    ]}
    closeText="Cancel"
  >
    <p>Are you sure you want to delete the lottery configuration?</p>
  </ModalComponent>
))

const ConfirmRunLottery = connect()(({ dispatch, running = false, lotteryConfiguration }) => (
  <ModalComponent
    title='Confirm Run Lottery'
    buttons={[
      <button
        className='btn btn-primary'
        disabled={running}
        onClick={() => {
          dispatch(modals.actions.update({ running: true }))
          dispatch(lotteryConfigurations.actions.run(lotteryConfiguration.id))
            .then(() => dispatch(modals.actions.hide()))
            .then(() => dispatch(lotteryConfigurations.actions.markDirty()))
            .then(() => dispatch(flashMessages.actions.show({
              type: 'success',
              message: 'Lottery has been started successfully.',
              dismissible: true,
            })))
            .catch(() => {
              dispatch(modals.actions.update({ running: false }))
              dispatch(modals.actions.show('UnexpectedError'))
            });
        }}
      >
        {running ? 'Running...' : 'Run Lottery'}
      </button>
    ]}
    closeText="Cancel"
  >
    <p>Are you sure you want to run the production lottery for this configuration?</p>
    <p className="text-muted"><small>This action cannot be undone and will generate final lottery results.</small></p>
  </ModalComponent>
))

const mapDucksToProps = ({ page, perPage }) => ({
  customer: singleDuck(customers, 'current'),
  lotteryConfigurations: filterDuck(lotteryConfigurations, { page: page || 1, per_page: perPage }),
})

const mapDispatchToProps = dispatch => ({
  onCreateNew: (customer) => dispatch(modals.actions.show('LotteryConfigurationModal', {
    configuration: null,
    isLotteryPartitioned: customer?.is_lottery_partitioned
  })),
  onEdit: (configuration, customer) => dispatch(modals.actions.show('LotteryConfigurationModal', {
    configuration,
    isLotteryPartitioned: customer?.is_lottery_partitioned
  })),
  onDelete: (lotteryConfiguration) => dispatch(modals.actions.show('ConfirmRemoveConfiguration', { lotteryConfiguration })),
  onTest: (configuration) => dispatch(lotteryConfigurations.actions.test(configuration.id))
    .then(() => dispatch(lotteryConfigurations.actions.markDirty()))
    .then(() => dispatch(flashMessages.actions.show({
      type: 'success',
      message: 'The test lottery is running and will complete in the next few minutes.  Please refresh this page to check the status',
      dismissible: true,
    }))),
  onRun: (configuration) => dispatch(modals.actions.show('ConfirmRunLottery', { lotteryConfiguration: configuration })),
})

export default compose(
  withPagination,
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(LotteryConfigurationsIndex)
